module.exports = __webpack_public_path__ + "img/webpluginnocheck.d105b94.svg";